module.exports = __webpack_public_path__ + "static/media/img-location-newtaipei-zh.2ca9b6e2.svg";